import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import {
	DataTypesState,
	DataTypesStateFactory,
	DataTypesStateFactoryFromJS,
	IDataTypesState
} from '../dataTypes/entities/IDataTypesState';
import {
	DataSearchState,
	DataSearchStateFactory,
	DataSearchStateFactoryFromJS,
	IDataSearchState
} from '../dataSearch/entities/IDataSearchState';

interface IBaseDataSecurityState {
	activeChildPanelGuid: string | null;
	activeNodeId: string | null;
	loading: boolean;
}

export interface IDataSecurityState extends IBaseDataSecurityState {
	dataTypes: IDataTypesState;
	dataSearch: IDataSearchState;
}

export interface IReadonlyDataSecurityState extends IBaseDataSecurityState {
	dataTypes: DataTypesState;
	dataSearch: DataSearchState;
}

export type DataSecurityState = ReadonlyRecord<IReadonlyDataSecurityState>;

export const DataSecurityStateFactory = Record<IReadonlyDataSecurityState>({
	activeChildPanelGuid: null,
	activeNodeId: null,
	loading: false,
	dataTypes: DataTypesStateFactory(),
	dataSearch: DataSearchStateFactory()
});

export const DataSecurityStateFactoryFromJS = function (data: IDataSecurityState) {
	return DataSecurityStateFactory({
		...data,
		dataTypes: DataTypesStateFactoryFromJS(data.dataTypes),
		dataSearch: DataSearchStateFactoryFromJS(data.dataSearch)
	});
};
